import SearchBar from '../../../../../../components/blackrock/advisor-center/search-bar/SearchBar';
import { HeaderSearchData } from '../../../../../../components/blackrock/advisor-center/_types/header';
import { FocusEvent, KeyboardEvent, useRef } from 'react';
import ErrorBoundary from '../../../../../../_helpers/ErrorBoundary';
import closeOnFocusOutside from '../../_helpers/closeOnFocusOutside.ts';
import classNames from 'classnames';

import './HeaderSearch.scss';

type HeaderSearchProps = {
	isSearchOpened: boolean;
	search: HeaderSearchData;
	toggleSearch: (state: boolean) => void;
	rightAligned: boolean;
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const HeaderSearch: React.FC<HeaderSearchProps> = ({
	isSearchOpened,
	search,
	toggleSearch,
	rightAligned,
}) => {
	const { dcr, i18n, config } = search;
	const icon = isSearchOpened ? 'times' : 'search';
	const label = isSearchOpened ? i18n?.closeAriaLabel : i18n?.openAriaLabel;

	const searchIconRef = useRef<HTMLButtonElement>(null);
	const searchBarDrawerRef = useRef<HTMLDivElement>(null);

	//on Escape key up it closes the searchBar and focuses on the search icon
	const onKeyUpOnSearchBar = (event: KeyboardEvent<HTMLDivElement>) => {
		if (event.key == 'Escape' && isSearchOpened) {
			toggleSearch(false);
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			searchIconRef.current.focus();
		}
	};

	const onFocusOutOnSearchBar = (event: FocusEvent<HTMLDivElement, Element>) =>
		closeOnFocusOutside(
			event,
			toggleSearch,
			searchBarDrawerRef.current,
			searchIconRef.current,
			isSearchOpened
		);

	return (
		dcr &&
		i18n &&
		config && (
			<div className="blk-ac-header-search">
				<button
					ref={searchIconRef}
					onClick={() => toggleSearch(!isSearchOpened)}
					aria-label={label}
					aria-expanded={isSearchOpened}
					aria-controls="search-drawer"
					className={classNames('front-of-bg', {
						'right-aligned': rightAligned,
					})}
				>
					<i className={`icon-search fa fa-${icon}`} tabIndex={-1} />
				</button>

				<div className="drawer behind-bg" id="search-drawer">
					<div
						className={`drawer-wrapper ${isSearchOpened ? 'searchOpen' : ''}`}
						ref={searchBarDrawerRef}
						onKeyUp={onKeyUpOnSearchBar}
						onBlur={onFocusOutOnSearchBar}
						tabIndex={-1}
					>
						<ErrorBoundary
							fallback={
								<div className={'blk-ac-body-m blk-ac-space-xl'}>
									Sorry, an error occurred. The search bar is currently
									unavailable.
								</div>
							}
						>
							<SearchBar
								opened={isSearchOpened}
								dcr={dcr}
								config={config}
								i18n={i18n}
							/>
						</ErrorBoundary>
					</div>
				</div>
			</div>
		)
	);
};

export default HeaderSearch;
